import React, { useState } from "react";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { useLocation } from "react-router-dom";
import { post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { toast } from "react-toastify";

const CompanySpecialSlot = ({
  setShowPopup,
  dates,
  setDates,
  selectedDate,
  setSelectedDate,
  handleDateSubmit,
  option,
  type,
  getDateList,
}) => {
  const [realDay, setRealDay] = useState("06-02-2018");
  const [showSchedule, setShowSchedule] = useState(false);
  const [schedule, setSchedule] = useState([]);
  const [index_, setIndex_] = useState(0);

  const location = useLocation();
  const pathname = location.pathname;

  const handleDayClick = (day, ind) => {
    setSelectedDate(day);
    setRealDay(day);
    setIndex_(ind);
    setSchedule([]);
    setShowSchedule(false);
  };

  const handleDateRemove = async (item) => {
    let payload = {
      for_date: item?.date,
      knf_company_site_id: option?.value,
    };
    console.log("SpecialDeletePayload", payload);
    const res = await post(URL.SPECIAL_DATE_DELETE, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      getDateList(option, index_);
    }
  };

  const handleToggle = (ind, type, value) => {
    let temp = [...dates];
    if (type == "toggle") {
      temp[ind] = {
        ...temp[ind],
        [type]: value,
        start_time: "",
        end_time: "",
      };
      setDates(temp);
      if (!value) {
        handleDateRemove(temp[ind]);
      }
    } else {
      temp[ind] = {
        ...temp[ind],
        [type]: value,
      };
      setDates(temp);
    }
  };

  // console.log("schedule", schedule);

  const handleSubmit = () => {
    const updatedArray = [...schedule, realDay];
    setSelectedDate(updatedArray);
  };

  const permission = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );

  const companyAddAllowed =
    (permission?.includes("CAN-Add-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-slot") ||
    (permission?.includes("CAN-Add-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-sites-view");

  const companyStatusAllowed =
    (permission?.includes("CAN-Status-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-slot") ||
    (permission?.includes("CAN-Status-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-sites-view");

  return (
    <div className="dashRightView">
      {option?.value && (
        <div
          className={`slot-container ${pathname == "/alert-days" ? "opacity-25" : ""}`}
        >
          <div className="days-scroll">
            {dates?.map((day, ind) => {
              return (
                <button
                  key={ind}
                  className={`f2 fs-sm-10 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 day-btn ${
                    selectedDate == day?.id ? "active" : ""
                  }`}
                  onClick={() => handleDayClick(day?.id, ind)}
                >
                  {day?.for_date}
                </button>
              );
            })}
          </div>

          {type !== "slot" && (
            <>
              {pathname !== "/alert-days" && (
                <>
                  {companyAddAllowed && (
                    <div className="d-flex ac-je ">
                      <button
                        className="import-btn"
                        onClick={() => setShowPopup(true)}
                      >
                        import
                      </button>
                    </div>
                  )}
                </>
              )}
            </>
          )}

          {dates?.length > 0 ? (
            <div className="Oversall-box-special flex-column ac-ja w-50">
              <div className="d-flex ac-js gap-3 my-4">
                <h3 className="f3 fs-sm-19 fs-md-18 fs-lg-18 fs-xl-22 fs-xxl-27">
                  {dates?.[index_]?.for_date} Schedule
                </h3>
                {/* <div
                  className="gap-3 d-flex toggle-btn"
                  onClick={() => {
                    if (type !== "slot") {
                      handleToggle(
                        index_,
                        "toggle",
                        dates?.[index_]?.toggle ? false : true
                      );
                    }
                  }}
                >
                  {dates?.[index_]?.toggle ? (
                    <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                  ) : (
                    <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                  )}
                </div> */}
                <div
                  className="gap-3 d-flex toggle-btn"
                  onClick={() => {
                    if (type !== "slot") {
                      if (!companyStatusAllowed) return;

                      handleToggle(
                        index_,
                        "toggle",
                        dates?.[index_]?.toggle ? false : true,
                      );
                    }
                  }}
                  style={{ width: 89, height: 50, overflow: "hidden" }}
                >
                  {dates?.[index_]?.toggle ? (
                    <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                  ) : (
                    <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                  )}
                </div>
              </div>

              {dates?.length > 0 && dates?.[index_]?.toggle && (
                <div className="schedule-box ">
                  <div className="time-inputs">
                    <div>
                      <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                        Start Time (mins)
                        <br />
                        Working Hrs
                      </label>
                      <input
                        type="time"
                        value={dates?.[index_]?.start_time}
                        onChange={(e) => {
                          if (type !== "slot") {
                            handleToggle(index_, "start_time", e.target.value);
                          }
                        }}
                      />
                    </div>
                    <div>
                      <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                        End Time (mins)
                        <br />
                        Working Hrs
                      </label>
                      <input
                        type="time"
                        value={dates?.[index_]?.end_time}
                        onChange={(e) => {
                          if (type !== "slot") {
                            handleToggle(index_, "end_time", e.target.value);
                          }
                        }}
                      />
                    </div>
                    {type !== "slot" && (
                      <div className="ms-2 mt-5">
                        {companyAddAllowed && (
                          <button
                            className="submit-btn "
                            onClick={() => handleDateSubmit(index_)}
                          >
                            Submit
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center mt-4 p-5 border rounded bg-light">
              <p className="mb-0 f3 text-muted">
                No Special Holidays found for this site.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CompanySpecialSlot;
